import * as actions from '../actionTypes';
import { GET_ATTENDANCES, ADD_ATTENDANCE, UPDATE_ATTENDANCE, DELETE_ATTENDANCE, MARK_ATTENDANCE } from '../api';
import client from '../apolloClient';
import{setAttendanceModified} from './loadingActions.js';

export const deleteAttendance = (attendance_id) => async (dispatch) => {
    try {
        const action = { type: actions.DELETE_ATTENDANCE, payload: attendance_id };
        dispatch(action);
    } catch (error) {
        console.log(error);
    }
}

export const setAttendances = (data) => async (dispatch) => {
    try {
        const action = { type: actions.SET_ATTENDANCES, payload: data };
        await dispatch(action);
        dispatch(setAttendanceModified(false));
    } catch (error) {
        console.log(error);
    }
}
export const getAttendances = () => async (dispatch) => {
    try {
        const { data } = await client.query({
            query: GET_ATTENDANCES,
        });
        const action = { type: actions.SET_ATTENDANCES, payload: data.attendances };
        dispatch(action);
        await dispatch(setAttendanceModified(false));
    } catch (error) {
        console.log(error);
    }
}
export const addAttendance = (attendance) => async (dispatch) => {
    try {
        const action = { type: actions.ADD_ATTENDANCE, payload: attendance };
        dispatch(action);
    } catch (error) {
        console.log(error);
    }
}

export const updateAttendance = (updatedAttendance) => async (dispatch) => {
    try {
        const { data } = await client.mutate({
                mutation: UPDATE_ATTENDANCE,
                variables: { input: updatedAttendance},
            });
        const action = { type: actions.UPDATE_ATTENDANCE, payload: data.updateAttendance };
        dispatch(action);
    } catch (error) {
        console.log(error);
    }
}
export const cleanAttendances = () => async (dispatch) => {
    try {  
        const action = { type: actions.SET_ATTENDANCES, payload: [] };
        dispatch(action);
    } catch (error) {
        console.log(error);
    }
}

export const markAttendance = (attendance) => async (dispatch) => {
    try {
        const { data } = await client.mutate({
            mutation: MARK_ATTENDANCE,
            variables: { input: attendance },
        });

        const savedAttendance = data.markAttendance;
        const action = { type: actions.MARK_ATTENDANCE, payload: savedAttendance };
        dispatch(action);

    } catch (error) {

        console.log(error);
        throw error;
    }
}

